import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiChevronDown, FiBriefcase, FiUser, FiFlag } from 'react-icons/fi';

const CustomDropdown = ({ type, onSelect, value }) => {
  const [isOpen, setIsOpen] = useState(false);

  const options = type === 'category' 
    ? [{ value: 'All', icon: FiFlag }, { value: 'Work', icon: FiBriefcase }, { value: 'Personal', icon: FiUser }]
    : [{ value: 'All', icon: FiFlag }, { value: 'Low', icon: FiFlag }, { value: 'Medium', icon: FiFlag }, { value: 'High', icon: FiFlag }];

  const handleSelect = (selectedValue) => {
    setIsOpen(false);
    onSelect(selectedValue);
  };

  return (
    <div className="relative w-48 mb-4">
      <div
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-4 py-2 text-left bg-white rounded-full 
                   flex items-center gap-2 
                   text-slate-500
                   shadow-[-5px_-5px_10px_rgba(255,_255,_255,_0.8),_5px_5px_10px_rgba(0,_0,_0,_0.25)]
                   cursor-pointer
                   hover:shadow-[-1px_-1px_5px_rgba(255,_255,_255,_0.6),_1px_1px_5px_rgba(0,_0,_0,_0.3),inset_-2px_-2px_5px_rgba(255,_255,_255,_1),inset_2px_2px_4px_rgba(0,_0,_0,_0.3)]
                   hover:text-violet-500"
      >
        <span>{value}</span>
        <FiChevronDown className={`ml-auto transition-transform duration-300 ${isOpen ? 'transform rotate-180' : ''}`} />
      </div>
      <AnimatePresence>
        {isOpen && (
          <motion.ul
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2 }}
            className="absolute z-10 w-full mt-1 bg-white rounded-md shadow-lg"
          >
            {options.map((option) => (
              <motion.li
                key={option.value}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className={`px-4 py-2 cursor-pointer flex items-center gap-2 
                            ${value === option.value ? 'bg-violet-100 text-violet-600' : 'text-slate-700 hover:bg-gray-100'}`}
                onClick={() => handleSelect(option.value)}
              >
                <option.icon className="mr-2" />
                {option.value}
              </motion.li>
            ))}
          </motion.ul>
        )}
      </AnimatePresence>
    </div>
  );
};

export default CustomDropdown;